import React, { useRef, useEffect, memo, useState } from 'react'
import Highcharts from 'highcharts'
import styled from 'styled-components'

// import Loading from './components/Loading'
import Loading from 'live/components/ui/Loading'

import { ChartOptions } from './ChartOptions'
import { WaitingEvents } from './components/WaitingEvents'

const ChartComponent = (props) => {
    const chartElement = useRef<HTMLDivElement>(null)
    const chart = useRef<Highcharts.Chart>(null)

    const Coptions = React.useMemo(() => ChartOptions(props), [props])

    // Register chart
    useEffect(() => {
        chart.current = Highcharts.chart(chartElement.current, Coptions)

        return () => {
            chart.current.destroy()
            chart.current = null
        }
    }, [Coptions, chart])

    // Reflow chart
    useEffect(() => {
        if (chart.current) {
            chart.current.reflow()
        }
    }, [props.width, props.height, props.state, props.widget])

    return (
        <Container>
            <div ref={chartElement} />
            <div className="chart-legend">
                {(props.state$._value.events[0].__status && props.widget.jsonConfig.description) && Object.entries(props.state$._value.events[0].__status).map((ent) => {
                    return ent.map(el => {
                        if (typeof(el) === 'string'){
                            return <span>{el}</span>
                        } else {
                            return <LegendColor style={{background: `${el.__color}`}} />
                        }
                    })
                })}
            </div>
        </Container>
    )
}

export const Chart = (props: LiveReactChartProps<any, ChartMessage, { widget: LiveWidget }>): JSX.Element => {
    const { loading = true, events = [] } = props?.state

    if (loading) return <Loading show={true} />
    if (events.length === 0) return <WaitingEvents />

    return <ChartComponent {...props} />
}

export default memo(Chart)

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: ${({theme}) => theme['gray-700']};

    .chart-legend {
        display: flex;
        align-items: center;
        -webkit-flex-direction: row-reverse;
        flex-direction: row-reverse;
        justify-content: center;
        padding: 0 10px;
        font-size: 11px;
        text-transform: uppercase;

        span {
            margin-top: 4px;
        }
    }
`

const LegendColor = styled.div`
    width: 16px;
    height: 16px;
    border-radius: 8px;
    margin: 0 4px 0 12px;
`
